import React from "react";
import sortBy from "lodash/sortBy";
import PropTypes from "prop-types";
import { Table, TableRow, TableCell } from "./Table";
import FranchiseStaffListRow from "./FranchiseStaffListRow";
import NewFranchiseStaffRow from "./NewFranchiseStaffRow";

const columnSizing = "2fr 1fr 1fr 1fr 40px";

const FranchiseStaffList = ({
  franchiseId,
  reinviteUser,
  franchiseMemberships,
  updateFranchiseMembership,
  deleteFranchiseMembership,
  ...otherProps
}) => {
  const sortedFranchiseMemberships = sortBy(franchiseMemberships, [
    "user.name",
    "user.email"
  ]);

  const renderStaffMember = franchiseMembership => {
    return (
      <FranchiseStaffListRow
        key={franchiseMembership.id}
        columns={columnSizing}
        franchiseId={franchiseId}
        franchiseMembership={franchiseMembership}
        updateFranchiseMembership={updateFranchiseMembership}
        deleteFranchiseMembership={deleteFranchiseMembership}
        reinviteUser={reinviteUser}
      />
    );
  };

  return (
    <Table noSideBorders {...otherProps}>
      <TableRow header columns={columnSizing}>
        <TableCell>User</TableCell>
        <TableCell justify="center">Owner</TableCell>
        <TableCell justify="center">Can Submit Jobs</TableCell>
        <TableCell justify="center">Salesperson</TableCell>
      </TableRow>
      {sortedFranchiseMemberships.map(renderStaffMember)}
      <NewFranchiseStaffRow
        franchiseId={franchiseId}
        columns={columnSizing}
        onSubmit={values => console.log("Submitting")}
      />
    </Table>
  );
};

FranchiseStaffList.propTypes = {
  franchiseMemberships: PropTypes.array.isRequired,
  updateFranchiseMembership: PropTypes.func,
  deleteFranchiseMembership: PropTypes.func
};

FranchiseStaffList.defaultProps = {
  updateFranchiseMembership: () => console.log("Updated"),
  deleteFranchiseMembership: () => console.log("Deleted")
};

export default FranchiseStaffList;



// WEBPACK FOOTER //
// ./src/components/FranchiseStaffList.js